module.exports = __webpack_public_path__ + "img/3.894b2a5d.webp";